import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVesselMovementSourceType implements BaseEnumType {
  private static allValues: EnumVesselMovementSourceType[] = []; // make sure this is top-most
  
  public static ingredients = new EnumVesselMovementSourceType(0, "Ingredients", "enum_vessel_movement_source_type_ingredients");
  public static vessel = new EnumVesselMovementSourceType(1, "Vessel", "enum_vessel_movement_source_type_vessel");
  public static measurement = new EnumVesselMovementSourceType(2, "Measurement", "enum_vessel_movement_source_type_measurement");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselMovementSourceType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isIngredients() { return this === EnumVesselMovementSourceType.ingredients; }
  public isVessel() { return this === EnumVesselMovementSourceType.vessel; }
  public isMeasurement() { return this === EnumVesselMovementSourceType.measurement; }

  public static getValues(): readonly EnumVesselMovementSourceType[] {
    return EnumVesselMovementSourceType.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselMovementSourceType[] {
    return EnumVesselMovementSourceType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselMovementSourceType {
    const found = EnumVesselMovementSourceType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselMovementSourceType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselMovementSourceType): EnumVesselMovementSourceType {
    const found = name ? EnumVesselMovementSourceType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselMovementSourceType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVesselMovementSourceType>): boolean {
    return this.key === other?.key;
  }
}